import styled from 'styled-components';
import { BasketSelectSectionStyled } from '../BasketCashPaymentSelectionStyled';
import { rem } from 'polished';

export const BasketCashPaymentSelectionAC = styled(BasketSelectSectionStyled)`
    .section {
        color: ${({ theme }) => theme.colors.grey5};
        border-color: ${({ theme }) => theme.colors.blue2};
        border-radius: ${rem(12)};

        .title {
            font-size: ${rem('16px')};
            .icon {
                .selected {
                    width: ${rem('16px')};
                    height: ${rem('16px')};
                    top: ${rem('3px')};
                    left: ${rem('3px')};
                    background: ${({ theme }) => theme.colors.blue2};
                }
            }
        }

        .inner {
            border-radius: ${rem(10)};
        }

        .description {
            font-size: ${({ theme }) => theme.fontSizes.h5};
        }

        &:hover,
        &:focus-visible {
            border: 1px solid ${({ theme }) => theme.colors.blue2};
            background: ${({ theme }) => theme.colors.white};

            .title .icon {
                background: ${({ theme }) => theme.colors.white};
            }

            .inner {
                border: 1px solid ${({ theme }) => theme.colors.blue2};
            }
        }

        &.selected {
            background: rgba(157, 199, 224, 0.2);
            border-color: ${({ theme }) => theme.colors.blue2};

            .inner {
                border: 1px solid ${({ theme }) => theme.colors.blue2};
            }
        }
        .summary {
            .totalPrice {
                font-size: ${({ theme }) => theme.fontSizes.h3};
            }
            .otherPrices {
                font-size: ${({ theme }) => theme.fontSizes.h5};
                border-color: ${({ theme }) => theme.colors.grey3};
                color: ${({ theme }) => theme.colors.grey5};
            }
        }
    }
`;
